import type { Airport, TripDetailsV2 } from "@b2bportal/air-shopping-api";
import { useModuleBEM } from "@b2bportal/core-themes";
import type {
  ITripTerminus,
  MulticityFlightShopStep,
  SortOptionEnum,
} from "@b2bportal/core-types";
import type { TripCategory } from "@overrides/types";
import {
  FlightListGridFilter,
  FlightShopTitle,
  FlightSummary,
  FlightSummaryLoading,
  Sort,
} from "@tenant/flights";
import { CfarReturnFilterBanner } from "../CfarReturnFilterBanner/CfarReturnFilterBanner";
import styles from "./ReturnPageHeader.module.scss";

interface ReturnPageHeaderProps {
  tripCategory: TripCategory;
  destination: ITripTerminus;
  sortOption: SortOptionEnum;
  handleSortChange: (value: SortOptionEnum) => void;
  tripDetails: TripDetailsV2 | null;
  multicityShopProgress: MulticityFlightShopStep;
  airports: { [key: string]: Airport };
}

export const ReturnPageHeader = ({
  tripCategory,
  destination,
  sortOption,
  handleSortChange,
  tripDetails,
  multicityShopProgress,
  airports,
}: ReturnPageHeaderProps) => {
  const [, cn] = useModuleBEM(styles, "ReturnPageHeader");

  return (
    <div className={cn("background-container")}>
      {tripDetails == null ? (
        <FlightSummaryLoading className={cn("flight-summary-loading")} />
      ) : (
        <div className={cn("flight-summary-container")}>
          {Array.from({ length: multicityShopProgress }, (_, i) => (
            <FlightSummary
              key={i}
              tripDetails={tripDetails}
              airports={airports}
              sliceIndex={i}
              className={cn("flight-summary")}
            />
          ))}
        </div>
      )}

      <FlightShopTitle
        className={cn("title-container")}
        tripCategory={tripCategory}
        destination={destination}
      />

      <div className={cn("sort")}>
        <Sort value={sortOption} handleSortChange={handleSortChange} />
      </div>

      <FlightListGridFilter className={cn("grid-filter")} />
      <div className={cn("cfar-filter-banner")}>
        <CfarReturnFilterBanner />
      </div>
    </div>
  );
};
